// action - state management
import { LOGIN, LOGOUT } from './actions';

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState = {
    isLoggedIn: false,
    isInitialized: false,
    username: null
};

const accountReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN: {
            const { username } = action.payload;
            return {
                ...state,
                isLoggedIn: true,
                isInitialized: true,
                username
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isInitialized: true,
                isLoggedIn: false,
                username: null
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
